module.exports = __webpack_public_path__ + "img/113.b804ae87.jpg";